import * as React from 'react';
import cssStyles from './index.scss';

export interface Props {
  /** Unique id */
  id?: string;
  /** Display the brand name */
  name?: string;
  /** Brand icon */
  image?: string;
  /** Icon wrapper styles (positioning) */
  style?: React.CSSProperties;
  /** Position on the creative */
  position?: string;
}

/**
 * Use `BrandBar` to display a brand bar
 */
export function BrandBar({ image, name, style, position }: Props) {
  return (
    <div className={cssStyles.brandBar}>
      <div
        style={style}
        className={
          position === 'right'
            ? cssStyles.brandBarContainer
            : cssStyles.brandBarContainerReverse
        }
      >
        {image && (
          <img className={cssStyles.brandbarLogo} src={image} alt="logo" />
        )}
        {name && <div className={cssStyles.brandbarName}>{name}</div>}
      </div>
    </div>
  );
}
